export default __webpack_public_path__ + "static/media/freemontKlein.cb91bb0c.jpg";